import {h} from 'preact';
import classNames from 'classnames';

export default function TaskSize(props) {
  const {
    sizes,
    state,
    setState,
  } = props;
  const renderedSizes = sizes.map(size => {
    return (
      <button
        key={size.id}
        data-value={size.name}
        className={classNames('task-size__item', {
          'task-size__item--active': size.id === state.size.id
        })}
        onClick={(e) => {
          e.preventDefault();
          setState({
            ...state,
            size: {
              id: size.id,
              name: size.name
            }
          })
        }}
      >
        {size.name}
      </button>
    )
  })
  return (
    <div className="task-size" style={{
      gridTemplateColumns: `repeat(${sizes.length} , 1fr)`
    }}>
      {renderedSizes}
    </div>
  )
}
